import {request} from '@/util/request'

//登录
export const loginApi = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/auth/login',
    method: 'post',
    data: data
  })
}

//退出登录
export const loginoutApi = () => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/auth/logout',
    method: 'post',
  })
}
//切换角色 {activeRoleValue}
export const switchRoleApi = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/auth/switch-identity',
    method: 'post',
    data: data
  })
}
/** 
 * 修改密码
 * @param {object} params ERP 主动修改密码请求
 * @param {string} params.oldPassword 旧密码（AES-128-ECB + Base64 加密后的密文）
 * @param {string} params.newPassword 新密码（AES-128-ECB + Base64 加密后的密文，至少8位，含字母和数字）
 * @returns
 */
export const changePasswordApi = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/auth/password/change',
    method: 'post',
    data: data
  })
} 
//查询用户菜单
export const getMenuListApi = () => {
  return request({
    url: '/webApi/pc/user/permission-info',
    method: 'get',
  })
}

//查询完整菜单树-
export const getMenuTreeApi = () => {
  return request({
    url: '/webApi/pc/menu/tree',
    method: 'get',
  })
}
//删除菜单
// /webApi/pc/menu/${permissionId}
export const deleteMenuApi = (permissionId) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/menu/${permissionId}`,
    method: 'delete',
  })
}
//创建菜单
// /webApi/pc/menu
export const createMenuApi = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/menu',
    method: 'post',
    data: data
  })
}
//更新菜单
// /webApi/pc/menu/${permissionId}
export const updateMenuApi = (data) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/menu`,
    method: 'put',
    data: data
  })
}
/****=================== 系统管理员 ====================*****/

//获取角色列表
export const getRoleListApi = (data) => {
  return request({
    url: '/webApi/pc/user/role/list',
    method: 'get',
    params: data
  })
}
//创建角色
export const createRoleApi = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/user/role',
    method: 'post',
    data: data
  })
}
//更新角色
export const updateRoleApi = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/user/role',
    method: 'put',
    data: data
  })
}
//查询角色已有权限 ID 列表
export const getRolePermissionsApi = (roleId) => {
  return request({
    url: `/webApi/pc/user/role/${roleId}/permissions`,
    method: 'get',
  })
}
//更新角色权限 ID 列表
export const updateRolePermissionsApi = (roleId, data) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/user/role/${roleId}/permissions`,
    method: 'put',
    data: data
  })
}
//禁用角色
export const disableRoleApi = (roleId) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/user/role/${roleId}/disable`,
    method: 'put',
  })
}
//查询角色权限树
export const getRolePermissionsTreeApi = () => {
  return request({
    url: '/webApi/pc/user/role/permissions/tree',
    method: 'get',
  })
}
//删除角色
// /webApi/pc/user/role/delete/{roleId}
export const deleteRoleApi = (roleId) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/user/role/delete/${roleId}`,
    method: 'post',
  })
}
/***用户管理------- */
//查询用户分页列表
export const getUserPageApi = (data) => {
  return request({
    url: '/webApi/pc/user/erp/page',
    method: 'post',
    data: data
  })
}
//重置用户密码
export const resetUserApi = ({userId, newPassword}) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/user/erp/${userId}/password/reset`,
    method: 'put',
    params: {
      newPassword: newPassword
    }
  })
}
//启用用户
export const enableUserApi = (erpUserId) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/user/erp/${erpUserId}/enable`,
    method: 'put',
  })
}
//禁用用户
export const disableUserApi = (erpUserId) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/user/erp/${erpUserId}/disable`,
    method: 'put',
  })
}
//创建用户
export const createUserApi = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/user/erp/create',
    method: 'post',
    data: data
  })
}
//查询用户详情
export const getUserDetailApi = (erpUserId) => {
  return request({
    url: `/webApi/pc/user/erp/${erpUserId}`,
    method: 'get',
  })
}
//更新用户
export const updateUserApi = (data) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/user/erp/${data.userId}/update`,
    method: 'post',
    data: data
  })
}
//删除用户
// /webApi/pc/user/erp/{userId}
export const deleteUserApi = (userId) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/user/erp/${userId}`,
    method: 'delete',
  })
}
//--------------机构管理-----------------//
//查询机构列表
export const getErpOrgListApi = (orgId) => {
  return request({
    url: '/webApi/pc/user/org/tree',
    method: 'get' ,
    params: {
      rootOrgId: orgId
    }
  })
}
//查询机构子列表
export const getErpOrgChildrenListApi = (parentId) => {
  return request({
    url: `/webApi/pc/user/org/children/${parentId}`,
    method: 'get' 
  })
} 
//查询机构详情
export const getErpOrgDetailApi = (orgId) => {
  return request({
    url: `/webApi/pc/user/org/${orgId}`,
    method: 'get',
  })
}
//创建机构
export const createErpOrgApi = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/user/org',
    method: 'post',
    data: data
  })
}
//更新机构
export const updateErpOrgApi = (orgId, data) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/user/org/${orgId}`,
    method: 'put',
    data: data
  })
}
//启用机构、禁用机构
export const enableErpOrgApi = ({orgId, disable}) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/user/org/${orgId}/${disable===1?'disable':'enable'}`,
    method: 'put',
  })
}
//

// ----------------------------------投资者管理----------------


///删除投资者
export const deleteInvestorApi = (userId) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/investor/manage/' + userId,
    method: 'delete'
  })
}
///停用/启用投资者
export const enableInvestorApi = (userId, disable) => {  
  return request({
    _showLoading: true,
    url: `/webApi/pc/investor/manage/${userId}/${disable?'disable':'enable'}`,
    method: 'put'
  })
}
//个人投资者分页列表
export const getIndividualInvestorPageList = (data) => {
  return request({
    url: '/webApi/pc/investor/manage/individual/page',
    method: 'post',
    data
  })
}
// 查看个人投资者详情
//   userId - 投资人id
// 返回值：InvestorDTO
export const getInvestorDetail = (userId) => {
  return request({
    url: '/webApi/pc/investor/manage/individual/' + userId,
    method: 'get'
  })
}



///新增个人投资者
export const addIndividualInvestor = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/investor/manage/individual',
    method: 'post',
    data
  })
}
///修改个人投资者信息
export const updateIndividualInvestor = (data, userId) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/investor/manage/individual/' + userId,
    method: 'put',
    data
  })
}


///公司投资者分页列表
export const getCompanyInvestorPageList = (data) => {
  return request({
    url: '/webApi/pc/investor/manage/company/page',
    method: 'post',
    data
  })
}

///新增公司投资者
export const addCompanyInvestor = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/investor/manage/company',
    method: 'post',
    data
  })
}

// 修改公司投资者信息
//   userId - 投资人id
//   data - 投资人信息
export const updateCompanyInvestor = (data, userId) => {
  return request({
    _showLoading: true,
    url: `/webApi/pc/investor/manage/company/${userId}`,
    method: 'put',
    data
  })
}
// 查看公司投资者详情
//   userId - 投资人id
// 返回值：InvestorDTO
export const getCompanyInvestorDetail = (userId) => {
  return request({
    url: `/webApi/pc/investor/manage/company/${userId}`,
    method: 'get'
  })
}

export const testApi = (erpUserId) => {
  return request({
    url: `/test`,
    method: 'get',
  })
}

/***提现配置 ------- */
//查询提现配置
export const getWithdrawConfigApi = () => {
  return request({
    url: '/webApi/app/system/configuration/get-withdraw-config',
    method: 'get',
  })
}

//查询账单分类配置
export const getWithdrawConfigListApi = () => {
  return request({
    url: '/webApi/pc/account/list',
    method: 'get',
  })
}
//保存提现配置
export const saveWithdrawConfigApi = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/account/save-withdraw',
    method: 'post',
    data: data
  })
}
//保存账单分类配置
export const saveBillConfigApi = (data) => {
  return request({
    _showLoading: true,
    url: '/webApi/pc/account/save-bill',
    method: 'post',
    data: data
  })
} 